import { RefObject, useEffect, useState } from "react";
import Editor, { Quill } from "react-quill";

// useQuillInstance.ts
export const useQuillInstance = (editorRef: RefObject<Editor>) => {
  const [quill, setQuill] = useState<Quill | null>(null);

  useEffect(() => {
    if (editorRef.current) {
      setQuill(editorRef.current.getEditor());
    }
  }, [editorRef.current]);

  return quill;
};
